var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "absolute lg:top-8 top-8 -left-28 md:top-1/4 landingbanner",
    xmlns: "http://www.w3.org/2000/svg",
    width: 151,
    height: 350,
    viewBox: "0 0 151 383",
    style: {
      translate: "none",
      rotate: "none",
      scale: "none",
      transform: "translate(0px, 0px)",
      opacity: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bone",
    d: "M0,307.41a75.443,75.443,0,0,1,25.45-56.6c9.536-13.8,32.735-57.552-1.637-120.121A75.5,75.5,0,1,1,136.85,119.659l.233.1s-.253.186-.714.559a75.964,75.964,0,0,1-11.847,12.762c-14.069,19.134-30.664,59.037,4.192,120.7A75.546,75.546,0,1,1,0,307.41Z",
    fill: "#C93172",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.56b5e9a5ece9f47cc8b60c60d76eb28c.svg";
export { ForwardRef as ReactComponent };